import { useId } from 'react';

interface BrandMarkProps {
  className?: string;
  title?: string;
}

export function BrandMark({ className, title }: BrandMarkProps): JSX.Element {
  const generatedId = useId();
  const titleId = title ? `${generatedId}-brand-mark-title` : undefined;
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : 'true'}
      aria-labelledby={titleId}
      focusable="false"
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5 96 50 4 95 96"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <path
        d="M50 20v76"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinecap="butt"
      />
      <path
        d="M24 70h52"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinecap="butt"
      />
      <path
        d="M8 96 33 83"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <path
        d="M92 96 67 83"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
    </svg>
  );
}
